import { FaGithub, FaLinkedinIn, FaLink } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiCodeforces, SiLeetcode } from "react-icons/si";

/**
 * Maps a social entry `id` from `data/profile.js` to its icon component.
 * `FaLink` is the fallback so an unrecognised id still renders something
 * sensible instead of crashing the tree with an undefined component.
 */
const iconsById = {
  github: FaGithub,
  linkedin: FaLinkedinIn,
  twitter: FaXTwitter,
  codeforces: SiCodeforces,
  leetcode: SiLeetcode,
};

export function getSocialIcon(id) {
  return iconsById[id] || FaLink;
}
